import { isEmpty } from 'lodash'
import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const sentenceUserTagsResolver: FieldResolver = (metadata: Metadata) => {
  if (metadata.getUserTags()) {
    return { sentenceUserTags: metadata.getUserTags() } as StreamData
  }

  return {
    sentenceUserTags: !isEmpty(metadata.getSentenceUserTags())
      ? (metadata
          .getSentenceUserTags()!
          .filter((sentenceUserTag) => !isEmpty(sentenceUserTag))
          .flatMap((sentenceUserTag) => sentenceUserTag) as string[])
      : []
  } as StreamData
}

export default sentenceUserTagsResolver
